export default __webpack_public_path__ + "static/media/vantagens.3fb1cb00.png";